// extracted by mini-css-extract-plugin
module.exports = {"footer":"gddsFooter_footer__EYykf","dummyToTopButton":"gddsFooter_dummyToTopButton__owXFH","gdds-element":"gddsFooter_gdds-element__qQyq_"};